import { createFeature, createReducer, on } from '@ngrx/store';
import * as actions from './rfr-mon-stacks.actions';
import * as luxon from 'luxon';
import { RfrMonStackI } from 'src/app/api/rfr-mon-stacks/rfr-mon-stacks.result.int';

  export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: RfrMonStackI[];
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: [],
    receivedTime: null,
};

export default createFeature({
  name: 'rfrMonStacks',
  reducer: createReducer(
  initialState,
  on(actions.load, (state: State): State => ({
    ...state,
    loaded: false,
    loading: true
  })),
  on(actions.received, (state: State, { data }): State => ({
    ...state,
    data,
    error: null,
    loaded: true,
    loading: false,
    receivedTime: luxon.DateTime.now().toISO()
  })),
  on(actions.reset, (state: State): State => ({
    ...state,
    data: null,
    error: null,
    loaded: false,
    loading: false
  })),
  on(actions.error, (state: State, { messageText }): State => ({
    ...state,
    error: messageText,
    loaded: false,
    loading: false
  })),
)}
);
